"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var ProposalForm_1 = require("./parts/ProposalForm");
var ProposalPackage_1 = require("./../../pdf/forms/asher/ProposalPackage");
function AsherProposal(props) {
    var json_data = react_redux_1.useSelector(function (_a) {
        var model = _a.model;
        return model.json_data;
    });
    var dispatch = react_redux_1.useDispatch();
    var _a = react_1.useState(true), displayForm = _a[0], setDisplayForm = _a[1];
    react_1.useEffect(function () { }, []);
    function onSave() {
        setDisplayForm(false);
    }
    var isPdf = false;
    if (window.isPdf) {
        isPdf = true;
    }
    return (react_1.default.createElement("div", null, displayForm && props.isStaffUser && !isPdf ? (react_1.default.createElement(ProposalForm_1.ProposalForm, { onSave: onSave })) : (react_1.default.createElement(ProposalPackage_1.ProposalPackage, { isStaffUser: props.isStaffUser }))));
}
exports.AsherProposal = AsherProposal;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvcG9zYWwuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJ2aWV3cy9Bc2hlclByb3Bvc2FsL3Byb3Bvc2FsLmNvbXBvbmVudC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkNBQWdEO0FBQ2hELDJDQUFvRDtBQUNwRCxxREFBaUQ7QUFDakQsMkVBQXVFO0FBR3ZFLFNBQWdCLGFBQWEsQ0FBQyxLQUFLO0lBQy9CLElBQU0sU0FBUyxHQUFHLHlCQUFXLENBQUMsVUFBQyxFQUFPO1lBQU4sZ0JBQUs7UUFBTSxPQUFBLEtBQUssQ0FBQyxTQUFTO0lBQWYsQ0FBZSxDQUFDLENBQUE7SUFDM0QsSUFBTSxRQUFRLEdBQUcseUJBQVcsRUFBRSxDQUFBO0lBQ3hCLElBQUEsMkJBQThDLEVBQTdDLG1CQUFXLEVBQUUsc0JBQWdDLENBQUE7SUFFcEQsaUJBQVMsQ0FBQyxjQUFPLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQTtJQUV2QixTQUFTLE1BQU07UUFDWCxjQUFjLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDekIsQ0FBQztJQUVELElBQUksS0FBSyxHQUFHLEtBQUssQ0FBQTtJQUVqQixJQUFJLE1BQU0sQ0FBQyxLQUFLLEVBQUU7UUFDZCxLQUFLLEdBQUcsSUFBSSxDQUFBO0tBQ2Y7SUFFRCxPQUFPLENBQ0gsMkNBQ0ssV0FBVyxJQUFJLEtBQUssQ0FBQyxXQUFXLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQzFDLDhCQUFDLDJCQUFZLElBQUMsTUFBTSxFQUFFLE1BQU0sR0FBSSxDQUNuQyxDQUFDLENBQUMsQ0FBQyxDQUNBLDhCQUFDLGlDQUFlLElBQUMsV0FBVyxFQUFFLEtBQUssQ0FBQyxXQUFXLEdBQUksQ0FDdEQsQ0FDQyxDQUNULENBQUE7QUFDTCxDQUFDO0FBMUJELHNDQTBCQyJ9